import script from "./CreateFormByLib.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFormByLib.vue?vue&type=script&setup=true&lang=js"

import "./CreateFormByLib.vue?vue&type=style&index=0&id=ec126edc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec126edc"]])

export default __exports__